import { useMemo } from "react";

import { obraTitulo } from "../../../resolver-conflito/resolver-conflito.utils";
import { REVISAO_LEGEND } from "../../resolver-conflito-fornecedor.constants";
import type {
  RevisaoFornecedorStepProps,
  RevisaoFornecedorStepViewModel,
} from "./types-revisao-fornecedor-step";
import { buildRevisaoFornecedorGantt } from "./revisao-fornecedor-step.utils";

/** Etapa Revisão: a troca que será feita, o aviso, o Gantt dos dois fornecedores e a justificativa. */
export function useRevisaoFornecedorStep({
  fornecedor,
  alocacao,
  escopo,
  continuaEm,
  substituto,
  carga,
  periodo,
  today,
  canceladaVisivel,
  disabled,
  justificativa,
}: RevisaoFornecedorStepProps): RevisaoFornecedorStepViewModel {
  const { rows, timeline } = useMemo(
    () =>
      buildRevisaoFornecedorGantt({
        fornecedor,
        alocacao,
        substituto,
        carga,
        periodo,
        today,
        canceladaVisivel,
      }),
    [fornecedor, alocacao, substituto, carga, periodo, today, canceladaVisivel],
  );

  return {
    fornecedorNome: fornecedor.nome,
    substitutoNome: substituto.nome,
    escopo,
    obraRotulo: obraTitulo(alocacao.obra),
    continuaEm:
      continuaEm.length > 0
        ? `A ${fornecedor.nome} continua na ${continuaEm.map((obra) => obraTitulo(obra)).join(" e na ")}.`
        : null,
    legenda: REVISAO_LEGEND.filter((item) => canceladaVisivel || item.key !== "cancelada"),
    rows,
    timeline,
    today,
    disabled,
    justificativa,
  };
}
